export enum TipoEstornoEnum {
  TOTAL = 'T',
	PARCIAL = 'P',
	NAO = 'N'
}

export interface TipoEstorno {
  nome: string;
  valor: TipoEstornoEnum;
}